<div class="note">
    <h4><i class="fas fa-lightbulb-on"></i> Tipps</h4>
    @if (!applicationStateService.userData.bookAccessCode) {
        <p><i
                class="fas fa-user-check"></i><span>Damit wir Deine {{ 'hsm.homework' | translation : applicationStateService.bookConfig.publisherText }}
            zuordnen können, gib bitte deinen Stickercode an.<br/> Die {{ 'hsm.homeworks' | translation : applicationStateService.bookConfig.publisherText }}
            werden sonst zukünftig nicht in der Liste erscheinen. <button
                    (click)="openDisabledModal()">Stickercode eingeben</button></span>
        </p>
    }
    <p>
        <i class="fas fa-link"></i><span>Erstelle eine {{ 'hsm.homework' | translation : applicationStateService.bookConfig.publisherText }}
        {{ variableText }} {{ 'hsm.homework' | translation : applicationStateService.bookConfig.publisherText }}.</span>
    </p>
    <p><i class="fas fa-analytics"></i><span>Die Auswertung wird automatisch an Deine angegebene E-Mail gesendet.</span>
    </p>
</div>
